import React from 'react';
import './style.scss'
import { useDispatch, useSelector } from 'react-redux';
import { handleRTL } from 'redux/layout';

const LanguageSwitcher = () => {

  const { isRTL } = useSelector((state) => state?.layout)
  const dispatch = useDispatch()
  
  const handleLang = ()=>{
    return !isRTL ? 'العربية' : 'English'
  }

  const hanldeClick = ()=>{
    dispatch(handleRTL(!isRTL))
  }

  return (
    <div className='LanguageSwitcher' onClick={hanldeClick}>
      {handleLang()}
    </div>
  );
}

export default LanguageSwitcher;
